export default class RiskTolerance {
  constructor() {
    this.questionnaire = {};
  }
}
